//Hooks
import { get } from 'svelte/store';
//Stores
import { user_data } from 'src/stores/account/user';
//Types
import type { Device } from 'src/types/Device';
import type { CircleAvatarPropsTypes } from '@Shelly/shelly-design-system/index';
//Helpers
import { convertDateFormat, time_zones } from './date_helper';
import { isBluTRV, load_image_from } from './interface_helpers';
import { getComponentByDevice } from './virtual_helpers/virtual_components_helpers';

export const getDeviceLastSeenData = (device: Device, status: any, settings: any) => {
	if (!device)
		return {
			lastSeenUpdate: undefined,
			time: undefined,
		};

	const tz = time_zones.includes(settings?.timezone || settings?.sys?.location?.tz)
		? settings?.timezone || settings?.sys?.location?.tz
		: get(user_data).timezone;

	let lastSeenUpdate = status?._updated;
	if (isBluTRV(device.type)) {
		const component = getComponentByDevice(device);
		lastSeenUpdate = status?.[component]?.last_updated_ts;
	}
	const time = convertDateFormat(lastSeenUpdate * 1000, tz);

	return {
		lastSeenUpdate,
		time,
	};
};

export const getDeviceIcon = (device: Device) => {
	if (device?.icon) return device.icon;

	if (!device.image && !device.backgroundColor) return 'fak fa-solid-shelly';
};

export const getDeviceImage = (device: Device) => {
	return device?.image
		? load_image_from(device?.image, device?.localImage ? '' : device?.server).replace('thumb_', '')
		: undefined;
};

export const getDeviceAvatarDefaultConfig = (
	device: Device,
	classes = 'mb-l',
): CircleAvatarPropsTypes & { class?: string } => {
	return {
		class: classes,
		size: 'xxl',
		image: getDeviceImage(device),
		icon: getDeviceIcon(device),
		backgroundColor: device?.backgroundColor,
	};
};
